let $ = jQuery

$(document).gp_ready(init_collapse)

function init_collapse() {
	$('.filter-collapse .filter-collapse__header').off("click").click(function () {
		let $filter = $(this).closest('.filter-collapse')
		toggle_collapse($filter)
	})
}

function toggle_collapse($filter) {
	if (!$filter.hasClass('opened')) {
		open_collapse($filter)
	} else {
		close_collapse($filter)
	}
}

export function open_collapse($filter) {

	// Trigger open to be able to stop it from elsewhere
	let data = {
		filter: $filter.data('filter'),
		open_collapse: true,
		scroll_parent: true
	}
	$(document).trigger('open_filter_collapse', data)

	if (data.open_collapse) {
		$filter.addClass('opened');
		$filter.children('.filter-collapse__content').slideDown(200);
	}

	if (data.scroll_parent) {
		setTimeout(function () {
			let $parent = $filter.parent()
			$parent.parent().animate({
				scrollTop: $filter.offset().top + $parent.scrollTop() - $filter.offsetParent().offset().top - 120
			}, 300)
		}, 200)
	}

}

function close_collapse($filter) {
	$('body').trigger('hide_overlay');
	$filter.removeClass('opened');
	$filter.children('.filter-collapse__content').slideUp(200);
}
